import React, { useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useParams, Link } from 'react-router-dom'
import { useLazyQuery } from '@apollo/react-hooks'
import { coursesQueries } from '../../graphql/queries';

const BackButton = () => {
  const { topicoId, cursoId } = useParams()
  const [fetchLastContent, { data: dataLastContent }] = useLazyQuery(coursesQueries.GET_LAST_VISITED_CONTENT, {
    variables: {
      curso_id: cursoId
    }
  })

  const lastContentId = ((dataLastContent || {}).ultimoConteudoAcessado || {})._id

  useEffect(() => {
    if (cursoId) {
      fetchLastContent()
    }
  }, []) // eslint-disable-line

  const routerLink = () => {
    if (topicoId) {
      return `/forum/${cursoId}`
    } else if (lastContentId) {
      return `/curso/${cursoId}/${lastContentId}`
    }
  }

  return (
    <IconButton
      component={Link}
      color="primary"
      aria-label="Voltar"
      to={routerLink()}
    >
      <ArrowBackIcon />
    </IconButton>
  );
}

export default BackButton
